import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ButtonContainer,
  DividerContainer,
  ExpertiseContainer,
  HeaderContainer,
  LeftContainer,
  ResultsBlocContainer,
  RightContainer,
  SearBarContainer,
  StepCardContainer,
  TextContainer,
  UrgencyContainer,
} from "./styled.components";
import { map } from "lodash";
import {
  ContactCard,
  Divider,
  ExpertiseCard,
  Layout,
  ResultsBloc,
  SearchBar,
  StepCard,
  Text,
  UrgencyBloc,
  UrgencyButton,
} from "../../components";
import { getIcons } from "../../helper/icons";
import { ReactComponent as HomeSVG } from "../../assets/illustrations/home.svg";
import domainData from "../../data/domains-data.json";
import { searchInAllData } from "../../helper/search";

const Home = () => {
  const navigate = useNavigate();
  const [results, setResults] = useState<SearchResult[] | null>();
  const [searchedValue, setSearchedValue] = useState<string>("");

  const onSearchValue = (value: string) => setSearchedValue(value);

  const onDeleteSearch = () => {
    setResults(null);
    setSearchedValue("");
  };

  const handleSearchResults = () => setResults(searchInAllData(searchedValue));

  return (
    <Layout>
      <>
        <HeaderContainer>
          <LeftContainer>
            <HomeSVG />
          </LeftContainer>
          <RightContainer>
            <ButtonContainer>
              <UrgencyButton />
            </ButtonContainer>
            <TextContainer>
              <Text weight={700} size="32px" lineHeight="40px">
                Est-ce que le Défenseur des droits peut vous aider ?
              </Text>
              <Text size="18px" color="grey400">
                Si vous pensez que certains de vos droits ne sont pas respectés,
                les juristes du Défenseur des droits peuvent vous aider.
              </Text>
            </TextContainer>
          </RightContainer>
        </HeaderContainer>
        <StepCardContainer>
          <StepCard
            color="blueLighter"
            step="ÉTAPE 1 - J'ai une demande car..."
            title="Recherchez ou sélectionnez le contexte de votre demande"
          />
        </StepCardContainer>
        <SearBarContainer>
          <SearchBar
            domain="default"
            searchedValue={searchedValue}
            onSearchValue={onSearchValue}
            handleSearchResults={handleSearchResults}
            onDeleteSearch={onDeleteSearch}
          />
        </SearBarContainer>
        {results ? (
          <ResultsBlocContainer>
            <ResultsBloc results={results} searchedValue={searchedValue} />
          </ResultsBlocContainer>
        ) : (
          <>
            <DividerContainer>
              <Divider />
            </DividerContainer>
            <ExpertiseContainer>
              {map(domainData, ({ domain, color, card }, index) => {
                return (
                  <ExpertiseCard
                    key={index}
                    onClick={() => navigate(`/${domain}`)}
                    color={color.default}
                    icon={getIcons(domain)}
                    title={card.title}
                    description={card.description}
                  />
                );
              })}
            </ExpertiseContainer>
          </>
        )}
        <ContactCard
          text="Vous avez des questions ? Le Défenseur des droits vous écoute et
            vous aide gratuitement partout en France."
        />
        <UrgencyContainer>
          <UrgencyBloc />
        </UrgencyContainer>
      </>
    </Layout>
  );
};

export default Home;
